<template>
  <div class="list-group-item">
    <v-row class="v-facet">
      <v-col cols="1">
        <v-btn class="zone-handle" icon>
          <i class="fa fa-arrows-v"></i>
        </v-btn>
      </v-col>
      <v-col cols="4">
        <v-checkbox
            :label="zoneProfileInstance.zone.translations[locale].label"
            v-model="zoneProfileInstance.isEnabled"
            @change="zoneCheckboxEnabled"
        ></v-checkbox>
      </v-col>
      <v-col cols="2">
        <v-switch
            v-model="isShowLabel"
            :label="Translator('admin.notice_collection.facets.label')"
            @change="zoneSwitchLabel"></v-switch>
      </v-col>
      <v-col cols="2">
        <v-select
          v-model="zoneProfileInstance.fontClass"
          :label="Translator('admin.notice_collection.facets.font_size')"
          @change="zoneSwitchFont"
          item-text="label"
          item-value="value"
          :outlined="true"
          :dense="true"
          :items="fontThemes"></v-select>
      </v-col>
      <v-col cols="1" offset="1">
        <v-menu
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab depressed small
              v-bind="attrs"
              v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-card>
            <!-- <v-divider></v-divider> -->
            <v-list>
              <v-list-item>
                <v-list-item-action>
                  <v-switch
                    v-model="zoneProfileInstance.topSpacing"
                    @change="zoneSwitchTopSpacing"></v-switch>
                </v-list-item-action>
                <v-list-item-title>{{ Translator('admin.notice_collection.facets.top_spacing') }}</v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-action>
                  <v-switch
                    v-model="zoneProfileInstance.bottomSpacing"
                    @change="zoneSwitchBottomSpacing"></v-switch>
                </v-list-item-action>
                <v-list-item-title>{{ Translator('admin.notice_collection.facets.bottom_spacing') }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-col>
      <v-col cols="1">
        <v-btn
            icon
            @click="isOpen = !isOpen">
          <v-icon>{{ isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <Field v-if="isOpen" :fields="zoneProfileInstance.fieldProfileInstances" :group="zoneProfileInstance.zone.id + '_zone'" :level="1"></Field>
  </div>
</template>
<style scoped lang="scss">
  .list-group-item {
    padding: 0;
    border: 0;
    border-left: 0;
    border-right: 0;
    .row {
      margin: 0;
      width: 100%;
    }
  }
  .v-input {
    &.v-input--selection-controls {
      margin-top: 0;
    }
  }
  .v-facet {
    border: rem(1) solid #ddd;
    .v-messages {
        display: none !important;
    }
    .v-label {
        font-weight: normal !important;
        font-size: 14px !important;
        margin-bottom: 0 !important;
    }
  }
</style>
<script>
import ZoneProfileInstanceAPI from '@/api/zoneProfileInstance'
import Field from '@/pages/AdminRenderingNotice/Field'

export default {
  name: 'AdminZone',
  components: {
    Field
  },
  props: [
    'zoneProfileInstance',
  ],
  data () {
    return {
      locale: window.Translator.locale,
      isOpen: false,
      drag: false,
      fontThemes: window.config.fontStyles.map((style, index) => { return { value: (index + 1).toString(), label: style.label } }),
      isShowLabel: this.zoneProfileInstance.showLabel
    }
  },
  methods: {
    zoneSwitchLabel (value) {
      ZoneProfileInstanceAPI.update(this.zoneProfileInstance.id, {showLabel: value})
    },
    zoneCheckboxEnabled (value) {
      ZoneProfileInstanceAPI.update(this.zoneProfileInstance.id, {isEnabled: value})
    },
    zoneSwitchFont(value) {
      ZoneProfileInstanceAPI.update(this.zoneProfileInstance.id, {fontClass: value})
    },
    zoneSwitchTopSpacing(value) {
      ZoneProfileInstanceAPI.update(this.zoneProfileInstance.id, {topSpacing: value})
    },
    zoneSwitchBottomSpacing(value) {
      ZoneProfileInstanceAPI.update(this.zoneProfileInstance.id, {bottomSpacing: value})
    },
    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    }
  },
  computed: {
    dragOptions () {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  }
}
</script>
